import { INITIALIZE_FILTER_FORM } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default (values) =>
    companyGeneralActions[INITIALIZE_FILTER_FORM](values);
